module.exports = __webpack_public_path__ + "static/media/Almarai-Regular.a19edc26.ttf";